export default "__VITE_ASSET__PhdDvS0J__"